import { usePartners, type Partner } from '@entities/partner'
import type { FormProps } from 'antd'
import { Button, Col, Form, Input, Row } from 'antd'
import { useEffect } from 'react'
import InputMask from 'react-input-mask'

interface MainFormProps {
    partner: Partner
    isLinkedPartner: boolean
}

type MainFormFields = {
    name: string
    tgUsername: string
    email: string
    phone: string
    comment: string
}

export const MainForm = ({ partner, isLinkedPartner }: MainFormProps) => {
    const {
        actions: { editPartner }
    } = usePartners()

    const onFinish: FormProps<MainFormFields>['onFinish'] = async (values) => {
        editPartner({ id: partner.id, data: { ...partner, ...values } })
    }

    const [form] = Form.useForm()

    useEffect(() => {
        form.setFieldsValue({
            name: partner.name,
            tgUsername: partner.tgUsername,
            email: partner.email,
            phone: partner.phone,
            comment: partner.comment
        })
    }, [form, partner])

    return (
        <Form
            form={form}
            name="edit-partner"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            onFinish={onFinish}
            initialValues={{
                name: partner.name,
                tgUsername: partner.tgUsername,
                email: partner.email,
                phone: partner.phone,
                comment: partner.comment
            }}
            onValuesChange={(val) => console.log(val)}
        >
            <Row gutter={16}>
                <Col span={4}>
                    <Form.Item
                        label="Имя"
                        name="name"
                        required={false}
                        rules={[{ required: true, message: 'Обязательное поле' }]}
                    >
                        <Input placeholder="Введите имя" readOnly={isLinkedPartner} />
                    </Form.Item>
                </Col>
                <Col span={20}></Col>
                <Col span={4}>
                    <Form.Item
                        label="Username в телеграм"
                        name="tgUsername"
                        required={false}
                        rules={[{ required: true, message: 'Обязательное поле' }]}
                    >
                        <Input placeholder="@username" readOnly={isLinkedPartner} />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item
                        label="E-mail"
                        name="email"
                        required={false}
                        rules={[{ required: true, message: 'Обязательное поле' }]}
                    >
                        <Input placeholder="helle@telegaplan.me" readOnly={isLinkedPartner} />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item
                        label="Номер телефона"
                        name="phone"
                        required={false}
                        rules={[{ required: true, message: 'Обязательное поле' }]}
                    >
                        <InputMask mask="+7(999)999-99-99" readOnly={isLinkedPartner}>
                            {(inputProps) => <Input {...inputProps} placeholder="Введите номер телефона" />}
                        </InputMask>
                    </Form.Item>
                </Col>
                <Col span={12}></Col>
                <Col span={4}>
                    <Form.Item label="Комментарий" name="comment" required={false}>
                        <Input.TextArea placeholder="Введите текст" readOnly={isLinkedPartner} />
                    </Form.Item>
                </Col>
                <Col span={20}></Col>
                <Col span={4}>
                    <Button type="primary" htmlType="submit" disabled={isLinkedPartner}>
                        Сохранить
                    </Button>
                </Col>
            </Row>
        </Form>
    )
}
